import { useState } from 'react'
import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useLatestArticlesByPage } from 'libs/client/api/articles'
import { ArticleItem } from 'types/data'
import { Pagination } from '../Pagination'
import { Article } from './Article'

export const LatestArticles = ({
  categorySlug,
  latestArticles,
  totalLatestArticles,
}: {
  categorySlug?: string
  latestArticles: Array<ArticleItem>
  totalLatestArticles: number
}) => {
  const offset = 9
  const { t } = useTranslation('@mc/next')

  const [page, setPage] = useState(1)
  const { articles }: { articles: Array<ArticleItem> } =
    useLatestArticlesByPage(page * offset, categorySlug)
  const lastPage = Math.trunc(totalLatestArticles / offset)

  return (
    <section className='mc-pb-9'>
      <h2 className='mc-text-h8 mc-text--uppercase mc-mb-2 align-self-start'>
        {t('article.latest.title')}
      </h2>

      {(page !== 1 ? articles : latestArticles)?.map((article) => (
        <Article article={article} key={article.title} />
      ))}

      <Separator className='mc-my-3 mc-w-100' />

      <Pagination
        totalPages={lastPage}
        currentPage={page}
        changePage={setPage}
      />
    </section>
  )
}
